import Vue from "vue";
import Vuetify from "vuetify/lib";
import { vuetifyConfig } from "@/config";

Vue.use(Vuetify);

export default new Vuetify(vuetifyConfig);
